// ;) Stolen with modifications from:
// https://github.bus.zalan.do/Team-Collab/sevsec-backend/blob/dev/app/controllers/helpers/keys.js
import { isUUID } from 'validator';
import { camelCase as camelCaseFunc, isArray, isObject, isPlainObject, isString, trim } from 'lodash';

const transformKeys = (obj, func) => {
  let newObj;

  if (isArray(obj)) {
    newObj = obj.map((item) => transformKeys(item, func));
  } else if (isPlainObject(obj)) {
    newObj = { ...obj };

    Object.keys(newObj).forEach((key) => {
      if ({}.hasOwnProperty.call(newObj, key)) {
        const newKey = !isUUID(key) ? func(key) : key;
        const temp = newObj[key];

        delete newObj[key];
        newObj[newKey] = temp;   // eslint-disable-line

        if (isArray(newObj[newKey])) {
          newObj[newKey] = newObj[newKey].map((item) => transformKeys(item, func));
        } else if (isPlainObject(newObj[newKey])) {
          newObj[newKey] = transformKeys(newObj[newKey], func);
        }
      }
    });
  } else {
    newObj = obj;
  }

  return newObj;
};

// lodash convert everything to snakeCase and now we have UUID and that means
// we will get weird results.
const snakeCaseFunc = (string) => string.replace(/([A-Z])/g, (char) => `_${char.toLowerCase()}`);

type ObjectWithAnyStringKeys = {
  [x: string]: any
};

export function camelCaseKeys(data: ObjectWithAnyStringKeys): ObjectWithAnyStringKeys {
  return transformKeys(data, camelCaseFunc);
}

export function snakeCaseKeys(data: any): any {
  return transformKeys(data, snakeCaseFunc);
}


// trim values recursively
export function trimPayload(payload: any): any {
  if (typeof FormData === 'function' && payload instanceof FormData) {
    // in case of file uploading
    return payload;
  }

  if (!isArray(payload) && !isObject(payload)) {
    // $FlowIgnore - In this branch, payload would always be a string when passed to trim
    return isString(payload) ? trim(payload) : payload;
  }

  return Object.keys(payload).reduce((acc, key) => {
    acc[key.trim()] = isString(payload[key]) ? trim(payload[key]) : trimPayload(payload[key]); // eslint-disable-line no-param-reassign
    return acc;
  }, isArray(payload) ? [] : {});
}
